/*
 * @Author: Ning
 * @Date: ****** 13:23:08
 * @LastEditTime: 2020-09-09 14:38:05
 * @LastEditors: Ning
 * @Description: System Logs 日志
 * @Do not edit
 */
import React from 'react';
import ReactDOM from 'react-dom';
import R from "./router";
import {Provider} from 'react-redux';
import store from './redux/store';
import {persistor}  from './redux/store';
import {PersistGate} from 'redux-persist/lib/integration/react';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import 'moment/locale/zh-cn';
import 'antd/dist/antd.css';
import './index.scss';
import 'core-js/es'
import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ConfigProvider locale={zhCN}>
                <R />
            </ConfigProvider>
        </PersistGate>
    </Provider>,
  document.getElementById('root')
);
